import { Component } from '@angular/core';

@Component({
    selector: 'app-management',
    imports: [],
    templateUrl: './management.component.html',
    styleUrl: './management.component.scss'
})
export class ManagementComponent {

}
